var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2966 36.8467C16.81 36.8467 20.47 33.1867 20.47 28.6733C20.47 24.16 16.8116 20.5 12.2966 20.5C7.78162 20.5 4.12329 24.16 4.12329 28.6733",
    stroke: "#643EE6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.305 36.855C11.075 36.855 9.90998 36.5833 8.86331 36.0983L3.83331 37.1667L4.88498 32.1267C4.39665 31.0767 4.12331 29.9067 4.12331 28.6733",
    stroke: "#643EE6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4283 20.5467C10.8317 19.1784 10.5 17.6867 10.5 16.1217C10.5 9.42672 16.4967 4.05505 23.8333 4.05505C31.17 4.05505 37.1667 9.42672 37.1667 16.1217C37.1667 20.0784 35.0633 23.5617 31.835 25.7584C31.8367 27.0184 31.8333 28.7167 31.8333 30.5001L26.6017 27.9234C25.7067 28.0951 24.7817 28.1884 23.8333 28.1884C22.655 28.1884 21.5117 28.0484 20.4217 27.7867",
    stroke: "#643EE6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/Social.e90d1e59d28efd5d7b8d0a0132a65479.svg";
export { ForwardRef as ReactComponent };